import React, { BaseSyntheticEvent } from 'react';
//
import colors from 'theme/colors';

interface Props {
  fill?: string;
  size?: number;
  onClick?: (e: BaseSyntheticEvent) => void;
}

const plotSize = 30;

const SurvivalIcon = ({ fill = colors.globalIcon, size = plotSize, onClick }: Props) => (
  <svg width={size} height={size} viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={onClick}>
    <path
      d="M4.50002 4.49948C4.50002 4.49948 4.84505 4.4993 6.84505 4.4993C10.3128 4.49916 9.99968 7.24917 11.4999 9.4994C13.0001 11.7496 16 11.4998 16 11.4998"
      stroke={fill}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SurvivalIcon;
